import styled, { css } from 'styled-components';

export const Container = styled.div<{ $collapsed: boolean }>`
  width: ${({ $collapsed }) => ($collapsed ? '72px' : '140px')};
  flex-shrink: 0;
  border-right: 1px solid #cccbcc;

  display: flex;
  flex-direction: column;

  transition: width 0.2s ease;

  .logoContainer {
    text-align: center;
    padding: ${({ $collapsed }) => ($collapsed ? '20px 0' : '30px 0')};

    img {
      width: ${({ $collapsed }) => ($collapsed ? '40px' : '104px')};
      height: auto;
      object-fit: contain;
      transition: width 0.2s ease;
    }
  }

  a {
    all: unset;
    cursor: pointer;
  }

  ${({ $collapsed }) =>
    $collapsed &&
    css`
      .menu p {
        display: none;
      }
    `}

  @media (max-width: 600px) {
    position: fixed;
    z-index: 20;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 64px;
    padding-bottom: env(safe-area-inset-bottom);
    border-top: 1px solid #cccbcc;
    border-right: 0;
    background: ${({ theme }) => theme.colors.background.white};

    .logoContainer,
    > button {
      display: none;
    }

    > ul {
      display: flex;
      width: 100%;
      height: 100%;
      margin: 0;
      overflow-x: auto;
      overflow-y: hidden;
      list-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      > a,
      > div {
        flex: 0 0 72px;
        width: 72px;
      }
    }
  }
`;

export const CollapseToggle = styled.button<{ $collapsed: boolean }>`
  align-self: ${({ $collapsed }) => ($collapsed ? 'center' : 'flex-end')};

  display: flex;
  align-items: center;
  justify-content: center;

  margin: auto 8px 16px;
  padding: 4px;

  background: transparent;
  border: 1px solid #cccbcc;
  border-radius: 8px;

  color: ${({ theme }) => theme.colors.muted};

  font-size: 18px;

  transition: 0.2s ease;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.orange.primary};
    color: ${({ theme }) => theme.colors.orange.primary};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
